import { useEffect, useSyncExternalStore } from "react";

/**
 * Sinal global de "carregando" para a barra fina sob o topo (TopProgress). Qualquer parte do app liga enquanto espera
 * (tela carregando sob demanda, consultas, gravações) e desliga ao terminar; a barra aparece enquanto houver alguém
 * esperando. Contador, não booleano: esperas simultâneas não se apagam umas às outras.
 */
let active = 0;
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

/** Liga o sinal; devolve a função que desliga (idempotente). */
export function startProgress(): () => void {
  active++;
  emit();
  let done = false;
  return () => {
    if (done) return;
    done = true;
    active = Math.max(0, active - 1);
    emit();
  };
}

export function progressActive(): boolean {
  return active > 0;
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** true enquanto alguém espera. */
export function useProgressActive(): boolean {
  return useSyncExternalStore(subscribe, progressActive, () => false);
}

/** Mantém o sinal ligado enquanto `on` for true (ex.: consultas em andamento). */
export function useProgressSignal(on: boolean): void {
  useEffect(() => (on ? startProgress() : undefined), [on]);
}
